import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
    FormArray,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { projectInsuranceContent } from '../../data/content';
import { scrollToFirstInvalidControl } from 'app/shared/utils';

@Component({
    selector: 'app-project-insurance-form',
    standalone: true,
    templateUrl: './project-insurance-form.component.html',
    styleUrls: ['./project-insurance-form.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        ReactiveFormsModule,
    ],
})
export class ProjectInsuranceFormComponent {
    @Output() onSubmit: EventEmitter<any> = new EventEmitter();
    @Input() selectedLanguage: string = 'en';
    @ViewChild('formContainer') formContainer!: ElementRef;

    form: FormGroup;
    content: any = projectInsuranceContent?.form?.fields;
    errors: any = projectInsuranceContent?.form?.errors;

    dropdownOpen = false;
    selectedValue: { en: string; bm: string } | null = null;

    natureOfBusinessOptions = [
        { en: 'Individual', bm: 'Individu' },
        { en: 'Sole Proprietorship', bm: 'Pemilikan Tunggal' },
        { en: 'Partnership', bm: 'Perkongsian' },
        {
            en: 'Professional Service Providers',
            bm: 'Penyedia Perkhidmatan Profesional',
        },
        { en: 'Sendirian Berhad', bm: 'Sendirian Berhad' },
        {
            en: 'Limited Liability Partnership',
            bm: 'Perkongsian Liabiliti Terhad',
        },
    ];

    constructor(private fb: FormBuilder) {
        this.form = this.fb.group({
            name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(2),
                    Validators.maxLength(30),
                ],
            ],
            projectTitle: [
                '',
                // [
                //     Validators.required,
                //     Validators.minLength(2),
                //     Validators.maxLength(192),
                // ],
            ],
            principalName: [
                '',
                // [
                //     Validators.required,
                //     Validators.minLength(2),
                //     Validators.maxLength(192),
                // ],
            ],
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
                    ),
                ],
            ],
            phoneNumber: [
                '',
                [Validators.required, Validators.pattern(/^[0-9]{10,11}$/)],
            ],
            typeOfInsurance: this.fb.array([], Validators.required),
            termsConditions: [false, Validators.requiredTrue],
        });
    }

    get insuranceTypes(): FormArray {
        return this.form.get('typeOfInsurance') as FormArray;
    }

    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }

    selectOption(value: { en: string; bm: string }, event: Event) {
        event.stopPropagation();
        this.selectedValue = value;
        this.form.get('natureOfBusiness')?.setValue(value.en);
        this.dropdownOpen = false;
    }

    onCheckboxChange(event: any) {
        if (event.target.checked) {
            this.insuranceTypes.push(this.fb.control(event.target.value));
        } else {
            const index = this.insuranceTypes.controls.findIndex(
                (x) => x.value === event.target.value
            );
            this.insuranceTypes.removeAt(index);
        }
        this.form.get('typeOfInsurance')?.updateValueAndValidity();
    }

    submitForm() {
        if (this.form.invalid) {
            scrollToFirstInvalidControl(this.formContainer.nativeElement);
            this.form.markAllAsTouched();
            return;
        }
        const finalObj = this.form.value;
        if (finalObj.projectTitle === '') delete finalObj.projectTitle;
        if (finalObj.principalName === '') delete finalObj.principalName;
        this.onSubmit.emit(finalObj);
    }
}
